// shopping types
export default {
  TOGGLE_MODAL: 'TOGGLE_MODAL',
};
